<template><div><h1>VUX V2.7.3 released</h1>
<h2><a href="/en/components/confirm.html">Confirm</a></h2>
<ul><li>[fix] fix hard to get focus on input(thanks to @Sapphire2k)</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[fix] disable-date-function result conflicts with disable-weekend #2189</li>
</ul>
<h2><a href="/en/components/picker.html">Picker</a></h2>
<ul><li>[enhance] add development tip for chained-mode picker without specifying prop:columns</li>
</ul>
<h2><a href="/en/components/rater.html">Rater</a></h2>
<ul><li>[feature] prop:star support html #2182</li>
</ul>
<h2><a href="/en/components/search.html">Search</a></h2>
<ul><li>[fix] fix event:on-change fires before compositionend</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.3 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.3-142.vue?3894003c